var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGitlab = function SvgGitlab(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "m12 20.33 3.317-10.2H8.689z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m4.043 10.13-1.01 3.098a.69.69 0 0 0 .25.768L12 20.33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M4.042 10.129h4.645L6.688 3.986c-.102-.315-.548-.315-.654 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m19.96 10.13 1.006 3.098a.69.69 0 0 1-.248.768l-8.719 6.334z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M19.962 10.129h-4.645l1.995-6.143c.102-.315.548-.315.654 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m12 20.33 3.315-10.2h4.645zM11.999 20.33l-7.957-10.2h4.645z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGitlab);
export default ForwardRef;